'use client'

import { useTranslations } from 'next-intl'
import { ArrowDown } from 'lucide-react'
import { PAIN_CHIPS } from './an-truong.constants'

export const PainPickerSection = () => {
  const t = useTranslations('landing_an_truong.pain_picker')

  const handleScrollToProduct = (targetId: string) => {
    const element = document.getElementById(targetId)
    if (element) {
      const yOffset = -80 // account for header sticky offset
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  return (
    <section className='w-full bg-white px-4 pt-7 pb-12 lg:px-[60px] lg:pt-[60px] lg:pb-20'>
      <div className='flex flex-col gap-3.5 lg:gap-6'>
        <h2 className='font-criteria text-2xl font-semibold leading-[35px] tracking-[-0.48px] text-neutral-900 lg:text-4xl lg:leading-[41px] lg:tracking-[-0.72px]'>
          {t('title')}
        </h2>

        <div className='flex flex-col gap-2.5 lg:flex-row lg:gap-5'>
          {PAIN_CHIPS.map((chip) => (
            <button
              key={chip.key}
              type='button'
              onClick={() => handleScrollToProduct(chip.targetId)}
              className='group flex w-full flex-1 items-center justify-between gap-4 rounded-2xl border border-neutral-200 bg-white py-4 pl-[18px] pr-5 text-left transition-colors duration-200 hover:border-neutral-900 lg:py-5 lg:pl-6 lg:pr-5'
            >
              <div className='flex flex-col gap-1'>
                <p className='font-criteria text-xl font-semibold leading-[30px] tracking-[-0.48px] text-neutral-900 lg:text-2xl lg:leading-[35px]'>
                  {t(`chips.${chip.key}.pain`)}
                </p>
                <p className='font-sans text-sm font-semibold leading-5 text-[#273bcd]'>
                  {t(`chips.${chip.key}.product`)}
                </p>
              </div>

              <div className='flex size-11 shrink-0 items-center justify-center rounded-full bg-[#f8f8f8] transition-colors group-hover:bg-neutral-200'>
                <ArrowDown className='size-[18px] text-neutral-900 transition-transform duration-200 group-hover:translate-y-0.5' />
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  )
}

